import React from 'react';
import { connect } from 'react-redux';

const NotFound = () => {
  return (
    <div>
      <h1>Page not found</h1>
    </div>
  );
};

function select(state) {
  return {
    data: state,
  };
}

export default connect(select)(NotFound);
